import { createContext, useContext } from 'react';
import type { ColSize } from '@george-labs.com/design-system/types/components/Layout';

interface ProductsListContext {
    labelClassName?: string;
    labelColumnWidth?: ColSize;
}

export const ProductsListContext = createContext<ProductsListContext>({});

export const useProductsListContext = (): ProductsListContext => useContext(ProductsListContext);
